import Link from "next/link";

function NavItem({ href, children }) {
  return (
    <li>
      <Link
        href={href}
        className="ml-4 px-3 text-2xl leading-[4rem] tracking-widest md:hover:underline md:hover:underline-offset-4 md:text-lg md:tracking-normal md:hover:text-white hover:text-temRed"
      >
        {children}
      </Link>
    </li>
  );
}

export default NavItem;
